import React from "react"
import SidePanelLayout from "aldoo-ra/SidePanel"
import RealtimeTab from "./components/RealtimeTab.jsx"
import HistoryTab from "./components/HistoryTab.jsx"
import StatsTab from "./components/StatsTab.jsx"
import SettingsTab from "./components/SettingsTab.jsx"

/**
 * Main History Browser Component
 * Shows realtime changes, history table, and statistics
 */
const HistoryBrowser = () => {
  return (
    <SidePanelLayout
      menuName="AdminChangesMenu"
      tabs={{
        live: RealtimeTab,
        history: HistoryTab,
        stats: StatsTab,
        settings: SettingsTab
      }}
    />
  )
}

export default HistoryBrowser
